module.exports = __webpack_public_path__ + "static/media/img_1_1685961477444.5f9dbf2a.jpg";